import { render, staticRenderFns } from "./HeadingArticle.vue?vue&type=template&id=0c1a75d0&scoped=true&lang=pug&"
import script from "./HeadingArticle.vue?vue&type=script&lang=js&"
export * from "./HeadingArticle.vue?vue&type=script&lang=js&"
import style0 from "./HeadingArticle.vue?vue&type=style&index=0&id=0c1a75d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1a75d0",
  null
  
)

export default component.exports